import { Record } from 'immutable'
import { RentalRateUnits } from './enums'

export interface IRentalRate {
  readonly rate: number
  readonly units: RentalRateUnits
}

const RentalRateRecord = Record({
  rate: 0,
  units: RentalRateUnits.PerMonth,
})

export class RentalRate extends RentalRateRecord implements IRentalRate {
  public static fromJS(initialState?: Partial<IRentalRate>) {
    return new RentalRate(initialState)
  }

  public readonly rate: number
  public readonly units: RentalRateUnits

  constructor(props?: Partial<RentalRate>) {
    props ? super(props) : super()
  }
}
